<script setup>
import { ref } from 'vue';
import WhatsAppTemplateParser from 'dashboard/components-next/whatsapp/WhatsAppTemplateParser.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

defineProps({
  template: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(['sendMessage', 'resetTemplate', 'scheduleMessage']);
const parserRef = ref(null);

const handleSendMessage = payload => {
  emit('sendMessage', payload);
};

const handleResetTemplate = () => {
  emit('resetTemplate');
};

const handleSchedule = () => {
  // Build the payload from the parser and emit for scheduling
  if (!parserRef.value) return;
  const parser = parserRef.value;
  if (parser.v$) {
    parser.v$.$touch();
    if (parser.v$.$invalid) return;
  }
  const { name, category, language, namespace } = parser.$props?.template || {};
  const payload = {
    message: parser.renderedTemplate,
    templateParams: {
      name,
      category,
      language,
      namespace,
      processed_params: parser.processedParams,
    },
  };
  emit('scheduleMessage', payload);
};
</script>

<template>
  <div class="w-full">
    <WhatsAppTemplateParser
      ref="parserRef"
      :template="template"
      @send-message="handleSendMessage"
      @reset-template="handleResetTemplate"
    >
      <template #actions="{ sendMessage, resetTemplate, disabled }">
        <footer class="flex gap-2 justify-end">
          <NextButton
            faded
            slate
            type="reset"
            :label="$t('WHATSAPP_TEMPLATES.PARSER.GO_BACK_LABEL')"
            @click="resetTemplate"
          />
          <NextButton
            faded
            slate
            type="button"
            :disabled="disabled"
            @click="handleSchedule"
          >
            <template #default>
              <span class="flex items-center gap-1.5">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
                </svg>
                Agendar
              </span>
            </template>
          </NextButton>
          <NextButton
            type="button"
            :label="$t('WHATSAPP_TEMPLATES.PARSER.SEND_MESSAGE_LABEL')"
            :disabled="disabled"
            @click="sendMessage"
          />
        </footer>
      </template>
    </WhatsAppTemplateParser>
  </div>
</template>
